import React from "react";

const PropertySkeleton = () => {
    return (
        <div className="tw-bg-white tw-rounded-lg tw-shadow-md tw-overflow-hidden tw-animate-pulse">
            {/* Image placeholder */}
            <div className="tw-w-full tw-h-[170px] tw-bg-gray-200"></div>

            {/* Content placeholder */}
            <div className="tw-p-4">
                {/* Price placeholder */}
                <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-24 tw-mb-3"></div>

                {/* Address placeholder */}
                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-2"></div>
                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-3"></div>

                {/* Property details placeholder (beds, baths, sqft) */}
                <div className="tw-flex tw-gap-4 tw-mb-3">
                    <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-12"></div>
                    <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-12"></div>
                    <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-16"></div>
                </div>

                {/* Status badge placeholder */}
                <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-16 tw-mb-3"></div>

                {/* Action buttons placeholder */}
                <div className="tw-flex tw-gap-2">
                    <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-flex-1"></div>
                    <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-8"></div>
                </div>
            </div>
        </div>
    );
};

export default PropertySkeleton;
